// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';

import { MerchantInfo } from '../../../organisms/merchant-info';
import { Separator } from '../../../atoms';

import { Ticket } from './ticket';
import { PixTips } from './pix-tip-box';
import { HelpBox } from './help-box';

export function PixPage(): Node {

  return (
    <Root data-test-id="pix-page-pending-payment">
      <Body>
        <Title>Código Pix gerado!</Title>
        <Subtitle>
          Falta pouco pra completar o seu pedido! Use os dados abaixo para pagar:
        </Subtitle>
        <Ticket />
        <Separator pattern="dashed" direction="vertical" size={5.5} />
        <PixTips />
        <Separator pattern="dashed" direction="vertical" size={5.5} />
        <HelpBox />
        <Separator direction="vertical" size={4.5} />
        <MerchantInfo />
      </Body>
    </Root>
  );
}

const Root = styled.div`
  color: ${props => props.theme.colors.gray(20)};
`;

const Body = styled.div`
  padding: 32px 16px;
`;

const Title = styled.p `
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  margin-bottom: 7px;
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
`;

const Subtitle = styled.div `
  margin-bottom: 24px;
`;
